import { useMemo } from 'react';

import useAuth from '@/hooks/useAuth';

export const useIsLastMatchDay = () => {
  const { userInitialData: initData } = useAuth();

  const isLastMatchDay = useMemo(() => {
    if (!initData?.todasLasFechas?.length || !initData?.fechaActiva) {
      return false;
    }

    const lastMatchDay = initData.todasLasFechas.slice(-1)[0];
    const isLastDay = lastMatchDay.id === initData.fechaActiva.id;

    return isLastDay && initData.veda;
  }, [initData]);

  return isLastMatchDay;
};
